import Swiper, { Navigation, Pagination } from "swiper";

export default class ComponentDestaquesBlog {
    constructor() {
        this.slider = document.querySelector(".swiper--component-destaques_blog");
        this.navigationPrev = document.querySelector(".slider-button-prev--component-destaques_blog");
        this.navigationNext = document.querySelector(".slider-button-next--component-destaques_blog");
        this.pagination = document.querySelector(".slider-pagination--component-destaques_blog");

        this.ready();
    }

    ready() {
        const slides = this.slider.querySelectorAll('.swiper-slide');
        const slidesCount = slides.length;

        const breakpoints = {
            0: {
                slidesPerView: 1.3,
                spaceBetween: 22,
                slidesOffsetBefore: 22,
                slidesOffsetAfter: 22,
            },
            768: {
                slidesPerView: 4.2,
                spaceBetween: 30,
            },
            1024: {
                slidesPerView: 3.99,
                spaceBetween: 30,
            },
            1600: {
                slidesPerView: 5.7,
                spaceBetween: 30,
            },
        };

        // Adiciona slidesOffsetAfter: 130 apenas se houver mais de 3 itens
        if (slidesCount > 3) {
            breakpoints[1024].slidesOffsetAfter = 130;
            breakpoints[1600].slidesOffsetAfter = 400;
        }

        const swiper = new Swiper(this.slider, {
            modules: [Navigation, Pagination],
            grabCursor: true,
            allowTouchMove: true,
            navigation: {
                nextEl: this.navigationNext,
                prevEl: this.navigationPrev,
            },
            pagination: {
                el: this.pagination,
                clickable: true,
            },
            breakpoints: breakpoints,
        });
    }
}